export default function Features() {
  const features = [
    {
      title: 'Enterprise Security',
      subtitle: 'Bank-level protection for your data',
      icon: 'ri-lock-2-line',
      gradient: 'from-purple-500/20 to-purple-700/20',
      image: 'https://public.readdy.ai/ai/img_res/255bc1ad8184e74669b64f756b688c74.jpg'
    },
    {
      title: 'Optimized Performance',
      subtitle: 'Smooth operation without compromise',
      icon: 'ri-speed-line',
      gradient: 'from-blue-500/20 to-blue-700/20',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20speed%20and%20performance%20visualization%20with%20dynamic%20flowing%20lines%20and%20particles%20in%20electric%20blue%20gradient%2C%20motion%20blur%20effect%20showing%20fast%20movement%2C%20modern%20minimalist%20tech%20design%20with%20energy%20waves%2C%20clean%20professional%20illustration%20on%20light%20background%2C%20optimized%20performance%20concept%20for%20iOS%20apps&width=500&height=500&seq=feature-performance-001&orientation=squarish'
    },
    {
      title: 'Intuitive Design',
      subtitle: 'Effortless navigation and control',
      icon: 'ri-layout-line',
      gradient: 'from-indigo-500/20 to-indigo-700/20',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20user%20interface%20elements%20with%20gesture%20indicators%20in%20soft%20gradient%20colors%2C%20minimalist%20design%20showing%20touch%20interactions%20and%20smooth%20navigation%20flow%2C%20modern%20clean%20tech%20illustration%20with%20geometric%20shapes%20on%20light%20background%2C%20intuitive%20UX%20concept%20for%20iOS%20mobile%20applications&width=500&height=500&seq=feature-design-001&orientation=squarish'
    }
  ];

  return (
    <section id="features" className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-20">
          <h2 className="text-6xl font-bold text-gray-900 mb-6">Why Choose Our Apps</h2>
          <p className="text-xl text-gray-600">Built with precision and user-centric design philosophy</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <article key={index} className="relative rounded-3xl overflow-hidden bg-white shadow-lg hover:shadow-xl transition-shadow aspect-square group cursor-pointer">
              <div className="absolute inset-0">
                <img 
                  src={feature.image}
                  alt={`${feature.title} - ${feature.subtitle}`}
                  title={feature.title}
                  className="w-full h-full object-cover"
                />
                <div className={`absolute inset-0 bg-gradient-to-br ${feature.gradient}`}></div>
              </div>
              
              <div className="relative h-full flex flex-col items-center justify-center p-8 bg-black/40 group-hover:bg-black/50 transition-colors">
                <div className="w-20 h-20 flex items-center justify-center mb-6">
                  <i className={`${feature.icon} text-6xl text-white`}></i>
                </div>
                <h3 className="text-3xl font-bold text-white text-center mb-4">{feature.title}</h3>
                <p className="text-base text-gray-200 text-center">{feature.subtitle}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}